module.exports = __webpack_public_path__ + "static/mixed-fb-sb-b3232713bdf623f9c72f0fc436ff6951.jpg";